export const appConfig = {
  appName: "mesh-jellybean",
  storagePrefix: "mesh-jellybean",
  description:
    "Wisdom-of-crowds estimator. Sealed-bid guesses via SHA-256 commit-reveal; reveal shows the full distribution.",
  accentHex: "#b07cd8",
  version: __APP_VERSION__,
  commit: __GIT_COMMIT__,
  repositoryUrl: "https://github.com/baditaflorin/mesh-jellybean",
  pagesUrl: "https://baditaflorin.github.io/mesh-jellybean/",
  signalingUrl:
    (import.meta.env.VITE_WEBRTC_SIGNALING as string | undefined) ?? "wss://turn.0docker.com/ws",
  turnTokenUrl:
    (import.meta.env.VITE_TURN_TOKEN_URL as string | undefined) ??
    "https://turn.0docker.com/credentials",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
} as const;
